import '../libs/slick'
import ConvertHeight from '../components/ConvertHeight'

export default class ModCarouselVideoSlick {
  constructor(el) {
    this.$el = $(el)

    this.elementsClasses = {
      videoItem: '.mod-carousel-video__item',
      videoItemContent: '.mod-carousel-video__content',
    }

    this.dom = {
      $slider: this.$el.find('.mod-carousel-video__slider'),
      $sliderControl: this.$el.find('.js-button-control'),
      $dots: this.$el.find('.js-slider-pagination'),
      $prevBtn: this.$el.find('.mod-carousel-video__button--prev'),
      $nextBtn: this.$el.find('.mod-carousel-video__button--next'),
      $heightItem: this.$el.find(this.elementsClasses.videoItem),
    }

    this.cssVariables = {
      animationPlayState: '--animation-play-state',
      animationDuration: '--animation-duration',
      transitionDuration: '--transition-duration',
      dotsAnimationClone: 'mcv-dots-animation-clone',
      dotsAnimation: 'mcv-dots-animation',
      animationName: 'animation-name',
      transitionTimingFunction: '--transition-timing-function',
    }

    this.classes = {
      videoItemActiveClone: 'mod-carousel-video__item--clone-active',
    }

    this.slideDuration = 5000
    this.slideSpeed = 600
    this.isUserInteraction = false
    this.transitionTimingFunction = 'ease'
  }

  init() {
    this.initSlider()
    this.handleEvents()
    this.setupAnimationEvents()
  }

  setupAnimationEvents() {
    this.dom.$dots.on('animationend', '.slick-active button', (_e) => {
      const currentButton = this.dom.$dots.find('.slick-active button')
      const currentAnimationName = currentButton.css(this.cssVariables.animationName)
      currentButton.css({
        [this.cssVariables.animationName]: currentAnimationName === this.cssVariables.dotsAnimationClone
          ? this.cssVariables.dotsAnimation
          : this.cssVariables.dotsAnimationClone,
      })
      this.dom.$slider.slick('slickNext')
    })
  }

  handleEvents() {
    // Slider events
    this.dom.$slider.on('beforeChange', this.handleBeforeChange.bind(this))
    this.dom.$slider.on('afterChange', this.handleAfterChange.bind(this))
    this.dom.$slider.on('breakpoint', this.callConvertHeight.bind(this))
  }

  handleBeforeChange(_event, slick, currentSlide, nextSlide) {
    this.animationLoopBC(slick, currentSlide, nextSlide)
  }

  handleAfterChange(_event, _slick, _currentSlide) {
    this.animationLoopAC()
  }

  callConvertHeight() {
    this.$el.removeClass('converted-height')
    const { videoItem, videoItemContent } = this.elementsClasses

    $(videoItem).each((_index, el) => {
      const $el = $(el)
      $el.height('')
    })

    $(videoItemContent).each((_index, el) => {
      const $el = $(el)
      $el.height('')
    })

    this.converterContent = new ConvertHeight($(videoItemContent))
    this.converter = new ConvertHeight($(videoItem))
    this.converterContent.convertHeight()
    this.converter.convertHeight()
    this.$el.addClass('converted-height')
  }

  initAnimation() {
    this.dom.$dots.css({
      [this.cssVariables.animationDuration]: `${this.slideDuration}ms`,
      [this.cssVariables.transitionDuration]: `${this.slideSpeed}ms`,
      [this.cssVariables.transitionTimingFunction]: this.transitionTimingFunction,
    })
  }

  animationLoopBC(slick, currentSlide, nextSlide) {
    const $currentSlide = slick.$slides.eq(currentSlide)
    // case slide from last to first
    if (nextSlide === 0 && currentSlide === slick.slideCount - 1) {
      $currentSlide.next().addClass(this.classes.videoItemActiveClone)
    }
    // case slide from first to last
    if (nextSlide === slick.slideCount - 1 && currentSlide === 0) {
      $currentSlide.prev().addClass(this.classes.videoItemActiveClone)
    }
  }

  animationLoopAC() {
    $(`.${this.classes.videoItemActiveClone}`).removeClass(this.classes.videoItemActiveClone)
  }

  handleInit(_event, _slick) {
    this.callConvertHeight()
    this.initAnimation()
  }

  initSlider() {
    this.dom.$slider.on('init', this.handleInit.bind(this))

    this.slider = this.dom.$slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      slide: this.elementsClasses.videoItem,
      arrows: true,
      nextArrow: this.dom.$nextBtn,
      prevArrow: this.dom.$prevBtn,
      dots: true,
      appendDots: this.dom.$dots,
      swipe: true,
      draggable: true,
      centerMode: true,
      centerPadding: '64px',
      infinite: true,
      speed: this.slideSpeed,
      variableWidth: true,
      initialSlide: 0,
      focusOnSelect: true,
      cssEase: this.transitionTimingFunction,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    })
  }
}

if (typeof window.acf === 'undefined') {
  $('.mod-carousel-video').each((_index, el) => {
    new ModCarouselVideoSlick(el).init()
  })
}